<template lang="pug">
div
  Header(:title="activity.theme || ''" backBtn @clickSecondaryBtn="showTexts = true" secondaryBtn secondaryBtnText="Textos motivadores" secondaryBtnIcon="ic:outline-visibility")
  v-divider
  v-row(justify="center" no-gutters style="background-color: #F7F8FA; height: 88.8vh")
    v-col(cols=7)
      v-container.mt-10
        v-row(justify="center")
          v-col
            v-card.pa-10(elevation=0)
              span(v-for="(part,i) of textParts")
                v-tooltip.d-inline-block(v-if="part.error && !editing" top)
                  template(v-slot:activator="{ on, attrs }")
                    span#texto.analise-error.analise-bold(v-on="on" v-bind="attrs" style="background: ") {{part.text}} ssss
                  span {{part.error.message}}
                v-menu.d-inline-block(v-else-if="part.error && editing" top :close-on-content-click="false")
                  template(v-slot:activator="{ on, attrs }")
                    span#texto.analise-error.analise-bold(v-on="on" v-bind="attrs" style="background: ") {{part.text}} 
                  CommentCard(:value="part.error" @deleteError="deleteError(part)" @input="editPart")
                span#texto(v-else)  {{ part.text }} 
    v-col(cols=5)
      .pa-8(style="background-color: #FFFFFF;")
        v-row(justify="space-between")
          v-col(cols="auto")
            .analise-heading-xs.mb-6(style="color: #005A73") Correção
          v-col(cols="auto")
            v-btn(outlined v-if="!editing" @click="startEditing")
              Icon.mr-1(icon="ic:outline-edit" width="18px")
              .analise-bold Editar
            v-btn.mr-4(color="error" outlined v-if="editing" @click="discardChanges")
              .analise-bold Descartar alterações
            v-btn(outlined v-if="editing" @click="saveChanges")
              .analise-bold Salvar
        v-divider
        v-row(justify="space-between" align="center")
          v-col(cols="auto")
            .analise-subtitle-xs.my-8 Nota geral
          v-col(cols="auto")
            v-chip(label x-large color="#F2FCFF")
              .analise-bold(style="color: #005A73") 880
        v-divider
        v-row(justify="space-between" align="center")
          v-col(cols="auto")
            .analise-subtitle-xs.my-6.analise-bold(style="color: #005A73") Comentário
          v-col(cols="auto" v-if="editing")
            v-btn(icon v-if="feedback.comentarios" @click="editingComments = true")
              Icon.mr-1(icon="ic:outline-edit" width="24px")
            v-btn(icon v-if="feedback.comentarios" @click="feedback.comentarios = null")
              Icon.mr-1(color="#920000" icon="ic:outline-delete" width="24px")
            v-btn(icon v-if="!feedback.comentarios" @click="editingComments = true")
              Icon.mr-1(icon="ic:outline-add" width="24px")
        .analise-subtitle(v-if="!feedback.comentarios && !editingComments") Nenhum comentário individual adicionado.
        .analise-subtitle(v-if="!editingComments") {{ feedback.comentarios }}
        div(v-if="editingComments")
          v-text-field(v-model="feedback.comentarios" filled label="Comentário" hide-details="auto" background-color="#F7F8FA")
          .mt-2
            v-row(no-gutters)
              v-col(cols=6)
                v-btn.mr-1(text block elevation=0)
                  .analise-bold Cancelar
              v-col(cols=6)
                v-btn.ml-1(color="#2D848E" block elevation=0 @click="editingComments = false")
                  .white--text.analise-bold Salvar
        .analise-subtitle-xs.my-6.analise-bold(style="color: #005A73") Detalhamento das competências
        v-expansion-panels(flat accordion)
          v-expansion-panel(v-for="(item,i) of feedback.competencias" :key="i" accordion)
            v-expansion-panel-header.px-0.py-5(class="justify-self-start" disable-icon-rotate)
              template(#actions)
                #nothing-here-to-hide-default-expand-icon
              v-row(align="center" no-gutters)
                v-col(cols=1)
                  Icon.mr-2(icon="ic:outline-chevron-right" width="24px")
                v-col(cols=7)
                  .analise-bold {{ i+1 }}. {{ item.explicacao }}
                v-col(cols=4)
                  v-row(align="center" justify="end")
                    v-col(cols="auto")
                      div(style="font-size: 14px") Nota
                    v-col(cols="auto")
                      v-chip(label small color="#F2FCFF")
                        .analise-bold(style="color: #005A73") 880
            v-divider
  v-navigation-drawer.no-shadow(
    v-model="showTexts"
    app
    right
    overlay-opacity="0.5"
    temporary
    width=610
  )
    .pa-4.pa-md-8
      v-row(justify="space-between")
        v-col(cols=11)
          .analise-heading-md.mb-2 {{ activity.theme }}
          v-chip(label small color="#F2FCFF")
            .analise-bold(style="color: #005A73") {{ activity.category }}
        v-col(cols=1)
          v-btn(icon @click="showTexts = false")
            v-icon mdi-close
      div.pt-6(v-html="activity.body")

      //- ================================================
      //- texto motivadores formatado corretamente abaixo
      //- ================================================ 
      //-  .pa-4.pa-md-8
      //- .analise-heading-md.mb-2
      //- span(v-if="!loading") {{ activity.theme }}
      //- v-skeleton-loader(v-if="loading" type="chip")
      //- v-chip(label small color="#F2FCFF")
      //-   .analise-bold(style="color: #005A73") {{ activity.category }}
      //- div.pt-6
      //-   v-skeleton-loader(v-if="loading" type="text@31, paragraph")
      //-   div(v-if="!loading" v-html="activity.body")
      //-   br
      //-   h3(v-if="!loading") TEXTO I
      //-   p(v-if="!loading") {{activity.text_1}}
      //-   h3(v-if="!loading") TEXTO II
      //-   p(v-if="!loading") {{activity.text_2}}
      //-   h3(v-if="!loading") TEXTO III
      //-   p(v-if="!loading") {{activity.text_3}}
  v-menu(v-model="selection.show")
    v-card.pa-2
      v-btn(text)
        Icon.pr-1(width="24px" icon="ic:outline-comment")
        | Adicionar comentário
</template>

<script>
import CommentCard from '@/components/CommentCard'

export default {
  components: {
    CommentCard
  },
  data() {
    return {
      loading: true,
      editing: false,
      editingComments: false,
      showTexts: false,
      sending: false,
      selection: {
        show: false,
        text: '',
      },
      feedback: {
          "texto": "Segundo o químico Antoine Lavoisier “na natureza nada se cria, nada se perde, tudo se transforma”. Desse modo, a relação homem-natureza tem se transformada de forma negativa, fato que pode ser comprovado com o exemplo brasileiro, onde o descaso da preservação do meio ambiente aliado à falta de efetivação das leis que regem a política contra queimadas causam problemas tanto na fauna e flora, quanto no clima. Em primeira análise, em 1998 foi criada a Lei de crimes Ambientais, visando a diminuição do desmatamento e de incêndios. No entanto, em função da grande extensão territorial das florestas brasileiras e da corrupção governamental a fiscalização é falha. Dessa maneira, de acordo com dados do Instituto Nacional de Pesquisa Espaciais (INPE), o desmatamento na Floresta Amazônica aumentou cerca de 96% no ano de 2019, isso ocorreu devido, principalmente, as queimadas ilegais gerando impacto na extinção de espécies vegetais e animais e na poluição do ar.  Além disso, o homem também é responsável pela degradação ambiental, devido ao fato do mau comportamento e do consumismo exacerbado que ocasiona o descarte excessivo do lixo e aumento da poluição. Ademais, a escolha de políticos pouco comprometidos com a causa e, também, a pouca exigência por parte da população implicam para a problemática da preservação do meio ambiente. No entanto, isso acontece pela falta de consciência quanto à importância da preservação do meio ambiente, principalmente nos setores de descarte de lixo e no uso consciente da água para que não haja desperdício. Nessa perspectiva, medidas são necessárias para resolver o impasse. Logo, é necessário que o Governo Federal, por meio do Ministério do Meio Ambiente efetivar o contingente fiscalizador da Lei de Crimes Ambientais aumentando as fiscalizações nas regiões onde ocorrem queimadas e desmatamentos. Além do mais, o Ministério da Comunicação deve promover campanhas educativas, por meio de palestras para conscientizar a população. Além de ocorrer parceria com a grande mídia digital para promover programas com debates sobre as atitudes que a sociedade pode tomar para ajudar na preservação ambiental. Para assim, a relação homem-natureza ser transformada de forma positiva.  ",
          "correcao": "Segundo o químico Antoine Lavoisier “na natureza nada se cria, nada se perde, tudo se transforma”. Desse modo, a relação homem-natureza tem se transformada de forma negativa, fato que pode ser comprovado com o exemplo brasileiro, onde o descaso da preservação do meio ambiente aliado à falta de efetivação das leis que regem a política contra queimadas causam problemas tanto na fauna e flora, <erro title='Estilo: Essa frase possui mais de 50 palavras na posição indicada, considere uma revisão' suggestions='Essa frase possui mais de 50 palavras na posição indicada, considere uma revisão'>quanto no</erro> clima. Em primeira análise, em 1998 foi criada a Lei de crimes Ambientais, visando a diminuição do desmatamento e de incêndios. No entanto, em função da grande extensão territorial das florestas brasileiras e da corrupção governamental a fiscalização é falha. Dessa maneira, de acordo com dados do Instituto Nacional de Pesquisa Espaciais (INPE), o desmatamento na Floresta Amazônica aumentou cerca de 96% no ano de 2019, isso ocorreu devido, principalmente, as queimadas ilegais gerando impacto na extinção de espécies vegetais e animais e na poluição do ar. Além disso, o homem também é responsável pela degradação ambiental, devido ao fato do mau comportamento e do consumismo exacerbado que ocasiona o descarte excessivo do lixo e aumento da poluição. Ademais, a escolha de políticos pouco comprometidos com a causa e, também, a pouca exigência por parte da população implicam para a problemática da preservação do meio ambiente. No entanto, isso acontece pela falta de consciência quanto à importância da preservação do meio ambiente, principalmente nos setores de descarte de lixo e no uso consciente da água para que não haja desperdício. Nessa perspectiva, medidas são necessárias para resolver o impasse. Logo, <erro title='Redundância: Expressão prolixa' suggestions='['deve']'>é necessário que</erro> o Governo Federal, por meio do Ministério do Meio Ambiente efetivar o contingente fiscalizador da Lei de CRIMES Ambientais aumentando as fiscalizações nas regiões onde ocorrem queimadas e desmatamentos. Além do mais, o Ministério da Comunicação deve promover campanhas educativas, <erro title='Redundância: Expressão prolixa' suggestions='['por', 'através de']'>por meio de</erro> palestras para conscientizar a população. <erro title='Estilo: Duas frases seguidas começam com o mesmo advérbio.' suggestions='Duas frases seguidas começam com o mesmo advérbio. Considere reformular a frase ou use um dicionário para encontrar um sinônimo.'>Além</erro> de ocorrer parceria com a grande mídia digital para promover programas com debates sobre as atitudes que a sociedade pode tomar para ajudar na preservação ambiental. Para assim, a relação homem-natureza ser transformada de forma positiva. ",
          "messagem": "",
          "nota_geral": 880,
          "competencias": [
              {
                  "id": 1,
                  "nota": 160,
                  "explicacao": "justificativa para nota da competência 1"
              },
              {
                  "id": 2,
                  "nota": 200,
                  "explicacao": "justificativa para nota da competência 2"
              },
              {
                  "id": 3,
                  "nota": 160,
                  "explicacao": "justificativa para nota da competência 3"
              },
              {
                  "id": 4,
                  "nota": 160,
                  "explicacao": "justificativa para nota da competência 4"
              },
              {
                  "id": 5,
                  "nota": 200,
                  "explicacao": "justificativa para nota da competência 5"
              }
          ],
          "comentarios": 'Parabéns pela redação! Importante revisar algumas regras gramaticais e a proposta de intervenção.',
          "code": 200,
          "html": "<p>Segundo o químico Antoine Lavoisier “na natureza nada se cria, nada se perde, tudo se transforma”. Desse modo, a relação homem-natureza tem se transformada de forma negativa, fato que pode ser comprovado com o exemplo brasileiro, onde o descaso da preservação do meio ambiente aliado à falta de efetivação das leis que regem a política contra queimadas causam problemas tanto na fauna e flora, <span style='background-color: #ffffff;color:#87b256;' title='Estilo: Essa frase possui mais de 50 palavras na posição indicada, considere uma revisão' suggestions='Essa frase possui mais de 50 palavras na posição indicada, considere uma revisão'><strong>quanto no</strong></span> clima. Em primeira análise, em 1998 foi criada a Lei de crimes Ambientais, visando a diminuição do desmatamento e de incêndios. No entanto, em função da grande extensão territorial das florestas brasileiras e da corrupção governamental a fiscalização é falha. Dessa maneira, de acordo com dados do Instituto Nacional de Pesquisa Espaciais (INPE), o desmatamento na Floresta Amazônica aumentou cerca de 96% no ano de 2019, isso ocorreu devido, principalmente, as queimadas ilegais gerando impacto na extinção de espécies vegetais e animais e na poluição do ar. Além disso, o homem também é responsável pela degradação ambiental, devido ao fato do mau comportamento e do consumismo exacerbado que ocasiona o descarte excessivo do lixo e aumento da poluição. Ademais, a escolha de políticos pouco comprometidos com a causa e, também, a pouca exigência por parte da população implicam para a problemática da preservação do meio ambiente. No entanto, isso acontece pela falta de consciência quanto à importância da preservação do meio ambiente, principalmente nos setores de descarte de lixo e no uso consciente da água para que não haja desperdício. Nessa perspectiva, medidas são necessárias para resolver o impasse. Logo, <span style='background-color: #ffffff;color:#1f1be1;' title='Redundância: Expressão prolixa' suggestions='['deve']'><strong>é necessário que</strong></span> o Governo Federal, por meio do Ministério do Meio Ambiente efetivar o contingente fiscalizador da Lei de CRIMES Ambientais aumentando as fiscalizações nas regiões onde ocorrem queimadas e desmatamentos. Além do mais, o Ministério da Comunicação deve promover campanhas educativas, <span style='background-color: #ffffff;color:#1f1be1;' title='Redundância: Expressão prolixa' suggestions='['por', 'através de']'><strong>por meio de</strong></span> palestras para conscientizar a população. <span style='background-color: #ffffff;color:#87b256;' title='Estilo: Duas frases seguidas começam com o mesmo advérbio.' suggestions='Duas frases seguidas começam com o mesmo advérbio. Considere reformular a frase ou use um dicionário para encontrar um sinônimo.'><strong>Além</strong></span> de ocorrer parceria com a grande mídia digital para promover programas com debates sobre as atitudes que a sociedade pode tomar para ajudar na preservação ambiental. Para assim, a relação homem-natureza ser transformada de forma positiva. </p>",
          "errors": [
              {
                  "start": 67,
                  "end": 69,
                  "word_start": "quanto",
                  "word_end": "no",
                  "type": "Estilo",
                  "message": "Essa frase possui mais de 50 palavras na posição indicada, considere uma revisão Essa frase possui mais de 50 palavras na posição indicada, considere uma revisão"
              },
              {
                  "start": 264,
                  "end": 267,
                  "word_start": "é",
                  "word_end": "que",
                  "type": "Redundância",
                  "message": "Expressão prolixa ['deve']"
              },
              {
                  "start": 307,
                  "end": 308,
                  "word_start": "por",
                  "word_end": "de",
                  "type": "Redundância",
                  "message": "Expressão prolixa ['por', 'através de']"
              },
              {
                  "start": 316,
                  "end": 316,
                  "word_start": "Além",
                  "word_end": "Além",
                  "type": "Estilo",
                  "message": "Duas frases seguidas começam com o mesmo advérbio. Duas frases seguidas começam com o mesmo advérbio. Considere reformular a frase ou use um dicionário para encontrar um sinônimo."
              }
          ],
          "codigo": 0
      },
      feedbackBackup: {}
    }
  },
  computed: {
    testeee() {
      const selection = document.getSelection()
      const text = selection.toString()
      if (selection.type !== 'None' && text) {
        return {
          show: true,
          text: text
        }
      } else return {
        show: false,
        text: ''
      }
    },
    activity() {
      const id = this.$route.params.id
      const activity = this.$store.getters['activities/getActivityById'](id)
      return activity || { theme: {} }
    },
    textParts() {
      const parts = []
      let lastError = null

      for (const error of this.feedback.errors) {
        const wordCount = ((error.end - error.start) + 1)
        
        const start = error.start - wordCount
        const end = error.end - wordCount

        const lastErrorEnd = lastError?.realEnd || 0
        if (!lastErrorEnd < start) {
          parts.push({
            text: this.feedback.texto.split(' ').slice(lastErrorEnd, start).join(' ')
          })
        }

        const errorPart = {
          text: this.feedback.texto.split(' ').slice(start, end).join(' '),
          error: {
            ...error,
            realStart: start,
            realEnd: end
          }
        }
        lastError = errorPart.error
        parts.push(errorPart)
      }

      const lastErrorEnd = lastError?.realEnd || 0
      const finalPart = this.feedback.texto.split(' ').slice(lastErrorEnd, this.feedback.texto.length).join(' ')

      if (finalPart) {
        parts.push({ text: finalPart })
      }

      return parts
    }
  },
  methods: {
    deleteError(part) {
      this.feedback.errors = this.feedback.errors?.filter(x => x.start !== part.error.start)
    },
    editPart(part) {
      const index = this.feedback.errors.findIndex(x => x.start === part.start)

      const formattedError = {
        start: part.start,
        end: part.end,
        word_start: part.word_start,
        word_end: part.word_end,
        type: part.type,
        message: part.message
      }

      if (index !== -1) {
        this.$set(this.feedback.errors, index, formattedError)
      } else {
        this.feedback.errors.push(formattedError)
      }

      this.$forceUpdate()
    },
    startEditing() {
      this.feedbackBackup = { ...this.feedback }
      this.editing = true
    },
    discardChanges() {
      this.feedback = { ...this.feedbackBackup }
      this.editing = false
    },
    saveChanges() {
      this.editing = false
    },
    onPointerUp() {
      const selection = document.getSelection()
      const text = selection.toString()
      if (selection.type !== 'None' && text) {
        this.$set(this.selection, 'show', true)
        this.$set(this.selection, 'text', text)
      }
    }
  },
  async created() {
    this.loading = true
    await this.$store.dispatch('activities/list')

    const eventt = this.onPointerUp
    document.addEventListener('selectionchange', eventt)
    this.loading = false
  }
}
</script>

<style scoped>
.no-shadow {
  box-shadow: none !important;
}

.analise-error {
  color: #005A73;
  background: #F2FCFF;
}
</style>